export const messages = {
  "zh-TW": {
    title: "輿情分析系統",
    workspace: "工作區",
    administration: "管理",
    dashboard: "工作台",
    newReport: "建立報告",
    account: "帳戶",
    adminOverview: "系統總覽",
    oneOffTestNav: "單次測試",
    reports: "報告",
    adminFlow: "分析流程",
    adminSources: "資料來源",
    adminSchedules: "排程",
    adminScheduleRuns: "排程記錄",
    adminPrompt: "目前 Prompt",
    adminModels: "模型與連線",
    adminUsage: "使用量",
    adminUsers: "帳戶管理",
    adminAudit: "系統紀錄",
    customer: "普通使用者",
    administrator: "管理員",
    forbidden: "你沒有權限查看這個頁面。",
    backToWorkspace: "返回工作台",
    signInDescription: "請使用獲授權的 GCS 帳戶登入。",
    loadingSession: "正在確認登入狀態…",
    activeJobs: "進行中的工作",
    deliveredReports: "已完成報告",
    noActiveJobs: "目前沒有進行中的工作。",
    comingSoon: "此功能正在分階段接入。",
    schedules: "報告排程",
    sources: "資料來源",
    model: "模型",
    createJob: "建立一次性測試",
    loading: "載入中…",
    oneOffTest: "建立一次性測試",
    profiles: "報告設定與自動排程",
    scheduleHint: "儲存一次後由 scheduler 自動建立報告；測試不會改變正式排程。",
    newProfile: "新增設定",
    profileEditor: "編輯報告設定",
    enabled: "啟用",
    disabled: "停用",
    edit: "編輯",
    test: "一次性測試",
    save: "儲存",
    cancel: "取消",
    noProfiles: "尚未建立報告設定",
    prompts: "Prompt 草稿與審批",
    promptHint: "Prompt 先測試，再送審、核准及 publish；不會直接變成 active schedule。",
    newPrompt: "新增 Prompt 草稿",
    submitApproval: "送出審批",
    approve: "核准",
    publish: "Publish",
    noPrompts: "尚未建立 Prompt 草稿",
    login: "登入",
    signingIn: "登入中…",
    logout: "登出",
    signingOut: "登出中…",
    loginHint: "請使用部署管理員提供的帳號登入。",
    language: "語言",
    theme: "主題",
    themeLight: "淺色",
    themeDark: "深色",
    themeSystem: "跟隨系統",
    username: "使用者名稱",
    password: "密碼",
    retry: "重試",
    cancelJob: "取消工作",
  },
  "en-US": {
    title: "Media Intelligence System",
    workspace: "Workspace",
    administration: "Administration",
    dashboard: "Dashboard",
    newReport: "New report",
    account: "Account",
    adminOverview: "System overview",
    oneOffTestNav: "One-off test",
    reports: "Reports",
    adminFlow: "Analysis flow",
    adminSources: "Sources",
    adminSchedules: "Schedules",
    adminScheduleRuns: "Schedule runs",
    adminPrompt: "Current Prompt",
    adminModels: "Models and connections",
    adminUsage: "Usage",
    adminUsers: "Account management",
    adminAudit: "System records",
    customer: "Customer user",
    administrator: "Administrator",
    forbidden: "You do not have permission to view this page.",
    backToWorkspace: "Back to workspace",
    signInDescription: "Sign in with an authorized GCS account.",
    loadingSession: "Checking session…",
    activeJobs: "Active jobs",
    deliveredReports: "Delivered reports",
    noActiveJobs: "There are no active jobs.",
    comingSoon: "This feature is being connected in phases.",
    schedules: "Schedules",
    sources: "Sources",
    model: "Model",
    createJob: "Create one-time test",
    loading: "Loading…",
    oneOffTest: "Create one-time test",
    profiles: "Report profiles and schedules",
    scheduleHint: "The scheduler creates reports automatically; a test does not change the active schedule.",
    newProfile: "New profile",
    profileEditor: "Edit report profile",
    enabled: "Enabled",
    disabled: "Disabled",
    edit: "Edit",
    test: "One-time test",
    save: "Save",
    cancel: "Cancel",
    noProfiles: "No report profiles yet",
    prompts: "Prompt drafts and approval",
    promptHint: "Test first, then submit, approve and publish; it does not directly change the active schedule.",
    newPrompt: "New prompt draft",
    submitApproval: "Submit for approval",
    approve: "Approve",
    publish: "Publish",
    noPrompts: "No prompt drafts yet",
    login: "Sign in",
    signingIn: "Signing in…",
    logout: "Sign out",
    signingOut: "Signing out…",
    loginHint: "Use the account configured by the deployment administrator.",
    language: "Language",
    theme: "Theme",
    themeLight: "Light",
    themeDark: "Dark",
    themeSystem: "System",
    username: "Username",
    password: "Password",
    retry: "Retry",
    cancelJob: "Cancel job",
  },
} as const;

export type Locale = keyof typeof messages;
export type MessageKey = keyof typeof messages["zh-TW"];
